import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Skill } from './skill';

export interface ToolsStore {
  loaded$: Observable<boolean>;
  allTools$: Observable<Skill[]>;
  init(): void;
  addTool(tool: Skill): void;
  editTool(tool: Skill): void;
  deleteTool(tool: Skill): void;
  editOrAddSuccess(): Observable<unknown>;
}

export const TOOLS_STORE = new InjectionToken<ToolsStore>('TOOLS_STORE');
